<select #select class="form-control select2" style="width: 100%;" (change)="changeSelectValue($event)"
  [(ngModel)]="value" [id]="Id" name="first">
  <option value="" selected disabled>Selecione</option>
  <option *ngFor="let item of data" [value]="item.Id">{{ item.Description }}</option>
</select>